/*** Generates random array of ints of given length. */

import getRandomInt from './randomInt';

const generateRandomData = (count: number, min: number, max: number): number[] => {
  let randomIntArr: number[] = [];

  for (let i = 0; i < count; i++) {
    randomIntArr.push(getRandomInt(min, max));
  }

  return randomIntArr;
};

export default generateRandomData;
